import dealService from 'resources/deal/deal.service';
import milestoneService from 'resources/milestone/milestone.service';

import * as dealHelpers from 'resources/deal/deal.helpers';

import { extendMilestonesWithTasks } from 'resources/milestone/milestone.operations';

const getUnderContractMilestonesWithTasksByDealId = async (dealId) => {
  if (!dealId) {
    return null;
  }

  const underContract = await milestoneService.getUnderContractMilestonesByDealId(dealId) || [];
  const afterClose = await milestoneService.getAfterCloseMilestonesByDealId(dealId) || [];

  return extendMilestonesWithTasks([...underContract, ...afterClose]);
};

const getPreContractMilestonesWithTasksByDealId = async (dealId) => {
  if (!dealId) {
    return null;
  }

  const milestones = await milestoneService.getPreContractMilestonesByDealId(dealId);

  return extendMilestonesWithTasks(milestones);
};

export const getMilestonesWithTasksByDealId = async (dealId) => {
  if (!dealId) {
    return null;
  }

  const deal = await dealService.findById(dealId);

  if (dealHelpers.hasNotStartedTransaction(deal)) {
    return getPreContractMilestonesWithTasksByDealId(dealId);
  }

  return getUnderContractMilestonesWithTasksByDealId(dealId);
};
